module.exports = __webpack_public_path__ + "static/media/3d-printer.172b6408.svg";